export default __webpack_public_path__ + "static/dinkity-high-resolution-logo-color-on-transparent-background-613daa1d0b24d98f290098c9dd6f1930.png";